import type { ComponentProps } from "react"
import { Progress as ProgressPrimitive } from "radix-ui"

import { cn } from "../lib/cn"

function Progress({ className, value, ...props }: ComponentProps<typeof ProgressPrimitive.Root>) {
  const indeterminado = value === null || value === undefined
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn("relative h-2 w-full overflow-hidden rounded-md bg-muted", className)}
      value={value}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "h-full bg-primary transition-all motion-reduce:transition-none",
          indeterminado ? "w-full opacity-30" : "w-full flex-1",
        )}
        style={indeterminado ? undefined : { transform: `translateX(-${100 - value}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
